import { lazily } from '@mkmp/core'
import { ContentLayout } from '@/features/layout/ContentLayout'

const { ApprovalCenter } = lazily(() => import('@/features/approval'))

/**
 * 审核中心
 */
export default [
  {
    id: Symbol('org-approval'),
    path: '/approval',
    element: <ContentLayout />,
    children: [
      {
        id: Symbol('org-approvalcenter'),
        path: 'center',
        handle: {
          code: 'org-approvalcenter'
        },
        element: <ApprovalCenter />
      }
    ]
  }
]
